import React, { useState } from 'react'
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Modal, Button, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import addAdminUser from '../../../api/addAdminUser';
import { showToastAction } from '../../../redux/toastSlice';

const initData = {
    first_name: "",
    last_name: "",
    email_adress: "",
    password: "",
    user_type: ""
}

const AddUserModal = ({ show, handleClose }) => {
    const [data, setData] = useState({ user_type: "MASTER" });
    const dispatch = useDispatch()
    const updateData = (key, value) => {
        const newData = { ...data };
        newData[key] = value;
        setData(newData);
    }

    const submitUser = async () => {
        // console.log('data', data);
        try {
            await addAdminUser(data);
            handleClose();
            dispatch(showToastAction({ message: "User added", showToast: true, severity: "success" }))
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                Add User
            </ModalHeader>
            <ModalBody>
                {/* <h3 className="fw-bolder mb-6">User 1</h3> */}
                <div className="flex flex-col gap-4">
                    <UserProperty property="First Name" value={data.first_name} onChange={(e) => updateData("first_name", e.target.value)} />
                    <UserProperty property="Last Name" value={data.last_name} onChange={(e) => updateData("last_name", e.target.value)} />
                    <UserProperty property="Email" value={data.email_adress} onChange={(e) => updateData("email_adress", e.target.value)} />
                    
                    <label className="label">
                        User Type
                        <Form>
                            <Form.Control as="select" onChange={(e) => updateData("user_type", e.target.value)}>
                                <option>MASTER</option>
                                <option>CAPTURE</option>
                                <option>ADMIN</option>
                            </Form.Control>
                        </Form>
                    </label>

                    {/* <UserProperty property="User type" value={data.user_type} onChange={(e) => updateData("user_type", e.target.value)} /> */}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="light" color="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="light" color="primary" onClick={submitUser}>
                    Add user
                </Button>
            </ModalFooter>
        </Modal>
    );
}

const UserProperty = ({ property, value, onChange, type }) =>
    <InputGroup>
        <InputGroupAddon addonType="prepend">
            <InputGroupText style={{ width: 100 }}>{property}</InputGroupText>
        </InputGroupAddon>
        <Input
            type={type || "text"}
            onChange={onChange}
            value={value}
        />
    </InputGroup>

export default AddUserModal
